import { Injectable, EventEmitter, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { KeysService } from './input-devices/keys.service';
import { EventInteraction } from '../dynamic/event.interaction.service';
import { Subscription } from 'rxjs/Subscription';
import { APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';

@Injectable()
export class UIAppHelper {
    renderer: Renderer2;
    private subscription: any;
    private isServer: boolean;

    constructor(
        @Inject(PLATFORM_ID) protected platformId: string,
        @Inject(APP_SETTINGS) private settings: any,
        private eventInteractions: EventInteraction) {
        this.isServer = isPlatformServer(this.platformId);

        if (!this.isServer) {
            console.log("UIAppHelper::init")
            this.subscription = this.eventInteractions.subscribe(e => {
                if (e.key == "changeBackgroundImage") {
                    this.changeBackgroundImage(e.message);
                }
                else if (e.key == 'removeBackgroundImage') {

                }
            });
        }
    }

    changeBackgroundImage(item: any) {
        if (!this.renderer || this.isServer || !document) return;

        let img = item.img, blur = item.blur;
        if (img && img.url) {
            let elem = document.getElementsByTagName("body")[0];
            if (elem) {
                var newImg = `url(${img.url})`;                
                if (newImg !== elem.style.backgroundImage) {
                    if (blur && this.settings.BACKGROUND_OVERLAY) {
                        this.renderer.addClass(elem, "blurred");
                    }
                    //elem.style.backgroundImage = newImg;
                    this.renderer.setAttribute(elem, "style", 'background-image: ' + newImg);
                    //this.renderer.setElementStyle(elem, '--background-image', newImg);
                }
            }
        }
    }

    removeBackgroundImage() {
        if (!this.renderer || this.isServer || !document) return;

        let elem = document.getElementsByTagName("body")[0];
        if (elem.style) {
            //this.renderer.removeStyle(elem, '--background-image');
            //elem.style.backgroundImage = null
            this.renderer.removeAttribute(elem, "style");
            this.renderer.removeClass(elem, "blurred");
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/ui.app.helper.ts